import TextWiw from './TextWiw';
export default TextWiw;
export * from './TextWiw.styles';
